<!--外包需求-->
<template>
  <div class="outsource-container">
    <headerIndex/>
    <div class="outsource-content" :style="'min-height:'+min_height+'px;'">
      <p class="title">交易大厅</p>
      <el-row :gutter="16">
        <el-col :span="16">
          <div class="left-outsource">
            <div class="outsource-button">
              <el-button type="primary" plain @click="releaseDemand">发布需求</el-button>
              <el-badge :value="transactionItem.tendersNum>0 ? transactionItem.tendersNum : ''" class="item">
                <el-button type="primary" plain @click="mineBidding">我的招标</el-button>
              </el-badge>
              <el-badge :value="transactionItem.bidsNum>0 ? transactionItem.bidsNum : ''" class="item">
                <el-button type="primary" plain @click="mineBid">我的投标</el-button>
              </el-badge>
              <el-badge :value="transactionItem.favoritesNum>0 ? transactionItem.favoritesNum : ''" class="item">
                <el-button type="primary" plain @click="mineCollection">我的收藏</el-button>
              </el-badge>
            </div>
            <div class="outsource-carousel">
              <el-carousel height="100%" direction="vertical" :autoplay="true" :interval="5000">
                <el-carousel-item v-for="item in transactionNotice">
                  <p class="outsource-carousel-p">
                    <span class="SourceHanSansCN">交易公告</span>
                    <el-divider direction="vertical"/>
                    <span>恭喜 </span>
                    <span class="red-span">[{{ item.tname }}]</span>
                    <span> 在交易任务 </span>
                    <span class="red-span">[{{ item.title }}]</span>
                    <span>中标成功。</span>
                  </p>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="release-demand" @click="releaseDemand"></div>
        </el-col>
      </el-row>
      <div class="screen-menu">
        <div class="screen-header">
          <div class="screen-left">
            <el-dropdown @command="checkScreen" trigger="click" style="padding-right: 20px;">
              <span class="el-dropdown-link">
                {{ sortType }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in screenOptions" :command="item"
                                  :class="sort==item.value ? 'isActive' : ''">
                  <span>{{ item.label }}</span>
                  <span v-if="item.label=='投标数'" style="padding-left: 40px;" @click="changeDesc">
                    {{ desc == 'desc' ? '降序' : '升序' }}<i class="el-icon-sort" style="padding-left: 5px"/>
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-cascader v-model="industry" :options="industryList" :show-all-levels="false" placeholder="行业" clearable
                         @change="changeIndustry" style="width: 110px;"/>
          </div>
          <div class="screen-right">
            <el-link icon="iconfont icon-screen" :underline="false" @click="dialogVisible=true">筛选</el-link>
          </div>
        </div>
        <div class="screen-content" v-if="demandList.length>0">
          <el-row :gutter="16">
            <el-col :span="8" v-for="demand of demandList" class="screen-list" style="padding: 0px 10px;">
              <div class="grid-content bg-purple" @click="biddingDetails(demand)">
                <i class="tag-1">
                  <span class="tag-red">招投标</span>
                  <span class="tag-white">{{ demand.money }}{{ demand.moneyUnit }}</span>
                </i>
                <i class="tag-2" v-if="demand.urgent==1">急</i>
                <i class="tag-2" v-if="demand.top==1">置顶</i>
                <p class="small-title SourceHanSansCN">{{ demand.title }}</p>
                <p class="bottom-p">
                <span class="left-span">
                  <i class="iconfont icon-clock"/>
                  {{ demand.statusFormat }}</span>
                  <span class="right-span">
                      <i class="iconfont icon-user"/>
                  {{ demand.nums }}人报名</span>
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="screen-content" v-else>
          <el-empty description="暂无内容"/>
        </div>
        <!-- 分页 -->
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage"
              :page="tablePage.currentPage" :limit="tablePage.pageSize" style="padding: 0px 20px 10px 10px;"/>
      </div>
    </div>
    <el-dialog title="筛选" :visible.sync="dialogVisible" width="30%" class="dialog">
      <el-form label-position="top" :model="screenData">
        <el-form-item label="招标状态">
          <el-radio-group v-model="screenData.status">
            <el-radio-button v-for="status of tenderStatus" :label="status.value">{{ status.name }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="截止时间">
          <el-radio-group v-model="screenData.endNums">
            <el-radio-button v-for="tender of tenderStatusTime" :label="tender.value">{{ tender.name }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="投标区域">
          <el-radio-group v-model="screenData.cityCode" @change="changeRadio">
            <el-radio-button :label="0">全部</el-radio-button>
          </el-radio-group>
          <el-select placeholder="请选择" v-model="screenData.province" style="width: 30%;margin-right: 20px;"
                     @change="changeSelect">
            <el-option v-for="item in provincialCode" :label="item.label" :value="item.value"/>
          </el-select>
          <el-select placeholder="请选择" v-model="screenData.city" style="width: 30%;" @change="changeCity">
            <el-option v-for="item in cityCode" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Reset">重 置</el-button>
        <el-button type="danger" @click="screen">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="20%" class="dialog">
      <p>您还未认证企业，暂无法发布需求。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="certifiedEnterprise">认证企业</el-button>
         <el-button @click="dialogVisible2=false">取消</el-button>
      </span>
    </el-dialog>
    <Hang/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {
  outsourcingIndustryList,
  tradingFloorsList,
  tenderStatusList,
  transactionAnnouncementList,
  tradingFloorStatistics
} from '@/api/cloudServiceApi'
import page from "@/components/page/pages";
import provincialCode from '@/static/provincialCode.json'

export default {
  name: "index",
  components: {home_footer, headerIndex, Hang, page},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 275,
      transactionNotice: [],
      screenOptions: [
        {value: 1, label: '综合排序', sort_name: '综合'},
        {value: 2, label: '最新发布', sort_name: '最新'},
        {value: 3, label: '投标数', sort_name: '投标数'},
      ],
      desc: 'desc',
      sortType: '综合',
      sort: 1,
      industry: '',
      industryList: [],
      cityList: {},
      cid: 0,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 12,
        total: 0,
      },
      demandList: [],
      provincialCode: provincialCode,
      cityCode: [],
      screenData: {
        status: 0,/*招标状态（0：全部，1：公示中，2：招标中，6：流标）*/
        endNums: 0,/*截止时间（0：全部，1：1天内，3：3天内，7：7天内）*/
        cityCode: 0,/*投标区域（全部为0*/
        province: '',
        city: '',
      },
      dialogVisible: false,
      dialogVisible2: false,
      tenderStatus: [],
      tenderStatusTime: [],
      personalInfo: {},
      transactionItem:[],
    }
  },
  methods: {
    /*获取行业分类*/
    getOutsourcingIndustryList() {
      outsourcingIndustryList().then(res => {
        if (res.code == 200) {
          for (let list of res.content) {
            let item = {value: list.id, label: list.name, children: []};
            if (list.sonList.length > 0) {
              for (let son of list.sonList) {
                let son_list = {pid: son.pid, value: son.id, label: son.name, children: []}
                if (son.sonList.length > 0) {
                  for (let sons of son.sonList) {
                    let sons_list = {pid: sons.pid, value: sons.id, label: sons.name}
                    son_list.children.push(sons_list);
                  }
                }
                item.children.push(son_list);
              }

            }
            this.industryList.push(item);
          }
        }
      })
    },
    /*切换状态调用查询接口*/
    checkScreen(command) {
      if (this.sort != command.value) {
        this.sortType = command.label;
        this.sort = command.value;
        this.tablePage.currentPage = 1;
        this.getTradingFloorsList();
      }
    },
    changeDesc() {
      if (this.desc == 'desc') {
        this.desc = 'asc';
      } else {
        this.desc = 'desc';
      }
      this.sortType = '投标数';
      this.sort = 3;
      this.tablePage.currentPage = 1;
      this.getTradingFloorsList();
    },
    /*获取推荐外包需求*/
    getTradingFloorsList() {
      tradingFloorsList({
        cityCode: this.screenData.cityCode,/*投标区域（全部为0*/
        endNums: this.screenData.endNums,/*截止时间（0：全部，1：1天内，3：3天内，7：7天内）*/
        industryId: this.industry[2],/*行业id*/
        method: this.desc,/*排序方法（asc：升序，desc：降序）*/
        page: this.tablePage.currentPage,/*分页*/
        pageLimit: this.tablePage.pageSize,/*每页条数*/
        status: this.screenData.status,/*招标状态（0：全部，1：公示中，2：招标中，6：流标）*/
        type: this.sort,/*排序方式（1：综合排序，2：最新发布，3：投标数）*/
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0 /*用户id*/
      }).then(res => {
        if (res.code == 200) {
          this.demandList = res.content.rows;
          this.tablePage.total = res.content.total;
        }
      })
    },
    screen() {
      this.tablePage.currentPage = 1;
      this.dialogVisible = false;
      this.getTradingFloorsList();
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getTradingFloorsList();
    },
    /*招标状态/截止时间 列表*/
    getTenderStatusList() {
      tenderStatusList({type: 2, uid: this.cid != 0 && this.cid != undefined ? this.cid : 0}).then(res => {
        if (res.code == 200) {
          this.tenderStatusTime = res.content;
        }
      })
      tenderStatusList({type: 1, uid: this.cid != 0 && this.cid != undefined ? this.cid : 0}).then(res => {
        if (res.code == 200) {
          this.tenderStatus = res.content;
        }
      })
    },
    /*重置*/
    Reset() {
      this.screenData = {status: 0, endNums: 0, cityCode: 0, province: '', city: ''};
    },
    /*监听省级城市切换*/
    changeSelect(event, item) {
      for (let province of this.provincialCode) {
        if (event == province.value) {
          this.cityCode = province.children;
        }
      }
    },
    /*监听切换二级城市*/
    changeCity(value) {
      this.screenData.cityCode = value;
    },
    /*切换选中全部区域*/
    changeRadio() {
      this.screenData.cityCode = 0;
      this.screenData.province = '';
      this.screenData.city = '';
      this.cityCode = [];
    },
    /*交易公告列表*/
    getTransactionAnnouncementList() {
      transactionAnnouncementList({
        page: 1,
        pageLimit: 100,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.transactionNotice = res.content.rows;
        }
      })
    },
    /*监听行业变更*/
    changeIndustry(value) {
      this.tablePage.currentPage = 1;
      this.getTradingFloorsList();
    },
    /*发布需求*/
    releaseDemand() {
      /**
       * @param verified_type 认证类型（1：个人，2：政府，3：企业，4：媒体，5：其他）
       * @param state 认证状态（1：已认证。0未认证,2:审核中，-1：认证失败）
       */
      if (this.cid!=0){
        if (this.personalInfo.verified_type == 3 && this.personalInfo.state == 1) {
          this.$router.push({path: '/outsourceDemand/releaseDemand',})
        } else {
          this.dialogVisible2 = true;
        }
      }else{
        this.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.replace({
              path: '/login'
            })
          }
        })
      }
    },
    /*认证企业*/
    certifiedEnterprise() {
      this.dialogVisible2 = false;
      let routeData = this.$router.resolve({
        name: "enterpriseCertification",
        path: '/officialCloud/enterpriseCertification',
      });
      window.open(routeData.href, '_blank')
    },
    /*我的招标*/
    mineBidding() {
      this.$router.push({path: '/outsourceDemand/mineBidding'})
    },
    /*我的招标*/
    mineBid() {
      this.$router.push({path: '/outsourceDemand/mineBid'})
    },
    /*我的收藏*/
    mineCollection() {
      this.$router.push({path: '/outsourceDemand/mineCollection'})
    },
    /*招标详情*/
    biddingDetails(demand) {
      this.$router.push({
        path: '/outsourceDemand/biddingDetails',
        query: {
          id:demand.zid
        }
      })
    },
    /*交易大厅数据统计*/
    getTradingFloorStatistics(){
      tradingFloorStatistics({ uid: this.cid != 0 && this.cid != undefined ? this.cid : 0}).then(res=>{
        if (res.code==200){
          this.transactionItem=res.content;
        }
      })
    }
  },
  mounted() {
    this.getTradingFloorsList();
    this.getTenderStatusList();
    this.getTransactionAnnouncementList();
    this.getTradingFloorStatistics();
  },
  beforeMount() {
    this.getOutsourcingIndustryList();
    this.personalInfo = sessionStorage.getItem('personalInfo') != null && sessionStorage.getItem('personalInfo') != undefined && sessionStorage.getItem('personalInfo') != '' ? JSON.parse(sessionStorage.getItem('personalInfo')) : '';
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style scoped>
.outsource-container >>> .outsource-content .el-button--primary.is-plain {
  background: #F3F9FF;
  border-color: #F3F9FF;
  padding: 25px 40px;
  font-size: 18px;
  color: #333333;
  font-weight: 100;
  border-radius: 8px;
  font-family: 'SourceHanSansCN';
}

.outsource-container >>> .outsource-content .el-button--primary.is-plain:hover {
  color: #333333;
  background: #ecf5ff;
  border-color: #b3d8ff;
}

.outsource-container >>> .outsource-content .left-outsource .outsource-carousel .el-carousel--vertical {
  overflow-y: hidden;
  background: #F5F5F5;
  padding: 15px 20px;
  border-radius: 8px;
}

.outsource-container >>> .outsource-content .left-outsource .el-carousel__container {
  position: relative;
  height: 100%;
  padding: 10px 0px;
}

.outsource-container >>> .outsource-content .left-outsource .el-carousel__indicators {
  display: none;
}

.outsource-container >>> .outsource-content .left-outsource .el-divider {
  background-color: #999999;
}

.outsource-container >>> .outsource-content .screen-menu .el-input__inner {
  background-color: #FFF;
  border: none;
  color: #FE273B;
  width: inherit;
}

.el-select-dropdown__item.selected {
  color: #FE273B;
  font-weight: normal;
}

.outsource-container >>> .outsource-content .screen-menu .el-select .el-input .el-select__caret {
  color: #FE273B;
}

.outsource-container >>> .outsource-content .screen-menu .el-input input::-webkit-input-placeholder {
  color: #FE273B;
}

.outsource-container >>> .outsource-content .screen-menu .el-input__prefix,
.outsource-container >>> .outsource-content .screen-menu .el-input__suffix {
  color: #FE273B;
}

.outsource-container >>> .outsource-content .screen-menu .screen-right .el-link.el-link--default {
  color: #333333;
}

.outsource-container >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FE273B;
  background-color: #FFF2F3;
  border-color: #FFF2F3;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.outsource-container >>> .el-radio-button__inner {
  background: #F7F7F7;
  border: 1px solid #F7F7F7;
  font-weight: normal;
  border-left: 1px;
  color: #272A3A;
  margin: 0px 15px 0px 0px;
  padding: 12px 20px;
  font-size: 14px;
  min-width: 110px;
  border-radius: 8px;
}

.outsource-container >>> .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
}

/* 设置dialog弹出框的样式 */
.dialog >>> .el-dialog__header {
  border-bottom: 1px solid #F7F7F7;
  padding: 15px 20px;
  background: #F7F7F7;
  vertical-align: middle;
}

/* 弹出框标题字体 */
.dialog >>> .el-dialog__title {
  font-size: 18px;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
  color: #333333;
}

.dialog >>> .el-dialog__body {
  border-top: 1px solid #EEEEEE;
  padding: 16px 20px 30px;
  color: #333333;
  font-size: 14px;
  word-break: break-all;
}
</style>
<style scoped lang="scss">
.outsource-container {

  .outsource-content {
    background: url("~@/assets/img/cloud/dealHall.png") no-repeat;
    background-size: 100% 100%;
    padding: 50px 18% 20px;
    min-width: 76rem;
    .title {
      color: #ffffff;
      font-size: 26px;
      margin-block-start: 0px;
      margin-block-end: 0px;
      padding-bottom: 50px;
    }

    .release-demand {
      background: url("~@/assets/img/cloud/releaseDemand.png") no-repeat;
      background-size: 100% 100%;
      height: 196px;
      cursor: pointer;
    }

    .left-outsource {
      background: #ffffff;
      height: 196px;
      border-radius: 8px;

      .outsource-button {
        display: flex;
        padding: 20px;
        justify-content: space-between;
      }

      .outsource-carousel {
        padding: 0px 20px;

        .outsource-carousel-p {
          margin-block-start: 0px;
          margin-block-end: 0px;
          font-size: 14px;
          font-family: inherit;
          cursor: pointer;

          .red-span {
            color: #FE273B;
          }
        }
      }
    }

    .screen-menu {
      background: #ffffff;
      border-radius: 8px;
      margin-top: 20px;
      padding: 0px 20px;

      .screen-header {
        display: flex;
        justify-content: space-between;
        padding: 5px 0px 15px;

        .screen-right {
          padding: 7px 0px;
        }
      }

      .screen-content {
        .el-col-8 {
          margin-bottom: 20px;

          .bg-purple {
            background: #F3F9FF;
            border-radius: 8px;
            padding: 30px 20px;

            .small-title {
              color: #333333;
              font-size: 18px;
              text-align: left;
              cursor: context-menu;
              margin-block-end: 0em;
              padding-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              word-wrap: break-word;
              word-break: break-all;

              .user-name {
                font-size: 16px;
                color: #333333;
              }

              .el-position {
                font-style: normal;
                font-size: 12px;
                color: #ffffff;
                background: #FF9600;
                padding: 3px 5px;
                border-radius: 4px;
                margin-left: 10px;
              }

              .right-icon {
                float: right;
                width: 30px;
                height: 30px;

                .icon-phone {
                  background: url("~@/assets/img/cloud/dianhua.png");
                  width: 30px;
                  height: 30px;
                  background-size: 100% 100%;
                  position: absolute;
                  cursor: pointer;
                }
              }
            }

            .gray-p {
              color: #999999;
              font-size: 14px;
            }

            .tag-1 {
              font-style: normal;
              cursor: pointer;

              .tag-red {
                padding: 10px;
                color: #ffffff;
                background: #FE273B;
                font-size: 14px;
                border-radius: 6px 0px 0px 6px;
                border: 1px solid #FE273B;
              }

              .tag-white {
                padding: 10px;
                color: #FE273B;
                background: white;
                font-size: 14px;
                border: 1px solid #FE273B;
                border-radius: 0px 6px 6px 0px;
              }
            }

            .tag-2 {
              font-style: normal;
              color: #FE273B;
              border-radius: 6px;
              border: 1px solid #FE273B;
              padding: 10px;
              margin-left: 20px;
              font-size: 14px;
              cursor: pointer;
            }

            .bottom-p {
              margin-block-start: 0em;
              margin-block-end: 0em;
              padding-top: 10px;

              .left-span {
                color: #666666;
                font-size: 14px;
              }

              .right-span {
                color: #666666;
                font-size: 14px;
                float: right;
              }

              .iconfont {
                color: #333333;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #FE273B;
  font-weight: normal;
}

.isActive {
  color: #FE273B;
}
</style>